import { Link } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function CTASection() {
  return (
    <section 
      className="py-20 bg-cover bg-center bg-no-repeat relative"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url('https://public.readdy.ai/ai/img_res/03956bac482df0c8a47e50ac4de39b83.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-6">
          Ready to Start Trading?
        </h2>
        <p className="text-xl text-gray-200 mb-8 max-w-3xl mx-auto">
          Join thousands of Nigerians who trust ListIt for their buying and selling needs. 
          Start your journey today and discover endless opportunities.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/signup">
            <Button variant="primary" size="lg" className="px-8 bg-green-600 hover:bg-green-700">
              <i className="ri-user-add-line mr-2"></i>
              Create Free Account
            </Button>
          </Link>
          <Link to="/post-ad">
            <Button variant="outline" size="lg" className="px-8 bg-white/10 border-white text-white hover:bg-white hover:text-gray-900">
              <i className="ri-add-line mr-2"></i>
              Post Your First Ad
            </Button>
          </Link>
        </div>
        
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-6 text-gray-300">
          <div className="flex items-center">
            <i className="ri-shield-check-line text-green-400 mr-2"></i>
            <span>100% Secure</span>
          </div>
          <div className="flex items-center">
            <i className="ri-customer-service-line text-green-400 mr-2"></i>
            <span>24/7 Support</span>
          </div>
          <div className="flex items-center">
            <i className="ri-money-naira-circle-line text-green-400 mr-2"></i>
            <span>Free to Start</span>
          </div>
        </div>
      </div>
    </section>
  );
}